<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2015-08-21</p>
    <div class="content">
      <!-- Content sections dynamically generated -->
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block">
            <p v-html="section"></p>
          </div>
        </div>
        <!-- Insert image after specific paragraph (e.g., after paragraph 3) -->
        <!-- <div v-if="index === 3" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture1?.url">
            <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
          </div>
        </div> -->
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'zhongkeyuandian');
  return newsItem || {};
});

// Split content into sections
const contentSections = computed(() => {
  return currentNews.value?.content ? currentNews.value.content.split('---') : [];
});

</script>

<style scoped lang="scss">


.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.content-section {
  margin-bottom: 30px;
}

.text-block {
  line-height: 1.6;
  
  p {
    margin-bottom: 15px;
  }
}

.image-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.image-container {
  margin-bottom: 20px;
  width: 60%; // Adjust as needed
  text-align: center;
  
  img {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

.image-caption {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style> 